<template>
  <section class="p-month" aria-labelledby="payments-monthly-title">
    <header class="p-month__header">
      <h2 id="payments-monthly-title" class="p-month__title">
        <span class="p-month__base">Claridad total</span> <br class="br-m"><span class="hl">sobre tus fechas</span>
      </h2>
      <p class="wd-body">
        Pagar a tiempo te ayuda <br class="br-m">a mantener tus beneficios activos durante todo el plazo.
      </p>
    </header>

    <div class="p-month__cards">
      <article v-for="card in cards" :key="card.title" class="p-month__card">
        <img :src="card.icon" alt="" aria-hidden="true">
        <p class="p-month__card-title">{{ card.title }}</p>
        <p class="wd-body">{{ card.body }}</p>
      </article>
    </div>

    <div class="p-month__note">
      <img :src="lightIcon" alt="" aria-hidden="true">
      <p>Pagar a tiempo te ayuda a mantener beneficios activos</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import lightIcon from '../../../assets/pagos-figma/icon-light.svg'
import fechaIcon from '../../../assets/pagos-figma/claridad-fecha.svg'
import puntualIcon from '../../../assets/pagos-figma/claridad-puntual.svg'
import fueraIcon from '../../../assets/pagos-figma/claridad-fuera.svg'

const cards = [
  {
    icon: fechaIcon,
    title: 'Fecha de pago',
    body: 'Realiza tu pago el día 1 de cada mes o el siguiente día hábil.'
  },
  {
    icon: puntualIcon,
    title: 'Pago puntual',
    body: 'Paga antes o el mismo día de tu fecha de pago para mantener el monto establecido.'
  },
  {
    icon: fueraIcon,
    title: 'Pago fuera de fecha',
    body: 'Si el pago se realiza después de la fecha límite, el monto puede actualizarse.'
  }
]
</script>

<style scoped>
.p-month { display: flex; flex-direction: column; gap: var(--ds-space-6); }
.p-month__header { display: flex; flex-direction: column; gap: var(--ds-space-3); }

.p-month__title {
  margin: 0;
  color: #6D59EA;
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}
.p-month__base { color: var(--ds-purple-900); }

.p-month__cards { display: flex; gap: var(--ds-space-6); }
.p-month__card {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-4);
  min-height: 236px;
  padding: var(--ds-space-4);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 8px;
  text-align: center;
}
.p-month__card img { width: 40px; height: 40px; }
.p-month__card-title {
  margin: 0;
  color: var(--ds-secondary-main);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}
.p-month__card .wd-body { margin-top: calc(var(--ds-space-3) - var(--ds-space-4)); }

.p-month__note {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  padding: var(--ds-space-2) var(--ds-space-3);
  background: var(--ds-grey-50);
  border-radius: 4px;
}
.p-month__note img { flex: 0 0 24px; width: 24px; height: 24px; }
.p-month__note p {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 14px;
  line-height: 20px;
}

@media (max-width: 599px) {
  .p-month__cards { flex-direction: column; }
  .p-month__card { flex: none; min-height: 0; }
}
</style>
